import { Avatar, Button, Chip, Grid, IconButton, Menu, MenuItem, Paper } from '@material-ui/core'
import { useQuery, useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import RoomIcon from '@material-ui/icons/Room';
import { getInfosDashboard } from '@webapps/business';
import {
  MoreHoriz,
  SchoolRounded as SchoolIcon,
  Work as WorkIcon,
  DescriptionRounded as DescriptionIcon,
  LocationOn as LocationOnIcon,
  CalendarToday as CalendarTodayIcon,
  Event
} from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import CardCandidatSkeleton from './CardCandidatSkeleton';

const CardCandidat = ({ candidature, viewCV, contactMember, addAffiliation, acceptCandidature, rejectCandidature, isLoading = false }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [anchorVitrine, setAnchorVitrine] = useState(null);
  const openCandid = Boolean(anchorVitrine);

  const handleClick = (event) => {
    setAnchorVitrine(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorVitrine(null);
  };

  // Get Subscription type
  const { isPremium } = useAuth();

  const getInterestChip = (level) => {
    switch (level) {
      case 1:
        return <Chip classes={{ colorPrimary: css({ background: '#C0D9FF', color: '#5D75A8' }) }}
          className={classes.chip}
          color="primary"
          label="Niveau d'intérêt: Neutre"
          size="small"
        />
      case 2:
        return <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
          className={classes.chip}
          color="primary"
          label="Niveau d'intérêt: Faible"
          size="small"
        />
      case 3:
        return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          className={classes.chip}
          color="primary"
          label="Niveau d'intérêt: Moyen"
          size="small"
        />
      case 4:
        return <Chip classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
          className={classes.chip}
          color="primary"
          label="Niveau d'intérêt: Elevé"
          size="small"
        />
      default:
        return <Chip classes={{ colorPrimary: css({ background: '#F3F7FF', color: '#5D75A8' }) }}
          className={classes.chip}
          color="primary"
          label="Niveau d'intérêt: Non renseigné"
          size="small"
        />
    }
  };

  const getStatusChip = (status) => {
    switch (status) {
      case 'PENDING':
        return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: En attente"
          size="small" />
      case 'ACCEPTED':
        return <Chip classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: Accepté"
          size="small" />
      default:
        return <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: Refusé"
          size="small" />
    }
  };

  const ImageProfil = ({ applicant }) => {
    const { css } = useStyles();
    const { data: infos = {} } = useQuery(getInfosDashboard, {
      key: ['imageProfile', applicant?.id],
      variables: { id: applicant?.id },
    });

    return infos?.profile?.profileImageUrl ?
      <Avatar className={css({ height: 50, width: 50, })} src={infos?.profile?.profileImageUrl} />
      :
      <Avatar className={css({ height: 50, width: 50, })}>
        {applicant?.lastname?.substr(0, 1)} {applicant?.firstname?.substr(0, 1)}
      </Avatar>
  };

  if (isLoading) {
    return <CardCandidatSkeleton />;
  }

  return (
    <Grid item xs={12} md={6} lg={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <Paper className={classes.paper} >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: spacing(2) }}>
          <div style={{ display: 'flex' }}>
            <ImageProfil applicant={candidature.applicant} />
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: spacing(2),
              })}
            >
              <div className={cx(global.title, classes.name)}>
                {candidature.applicant.firstname} {candidature.applicant.lastname}
                {/* <div className={css({ marginLeft: spacing(1) })}>
                                    <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                                </div> */}
              </div>
              <div className={cx(global.infoText, classes.address)}>
                <RoomIcon className={classes.roomIcon} />
                <div className={css({ marginLeft: '16px' })}>
                  {candidature.applicant.address?.cityCode} {candidature.applicant.address?.city}
                </div>
              </div>
            </div>
          </div>
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={openCandid ? 'candidature-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openCandid ? 'true' : undefined}
            style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }}>
            <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
          </IconButton>
          <Menu
            anchorEl={anchorVitrine}
            id="candidature-menu"
            open={openCandid}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{ elevation: 2 }}
            transformOrigin={{ horizontal: 'left', vertical: -50 }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          >
            <MenuItem disableRipple disableFocusRipple onClick={() => viewCV(candidature.applicant?.id, candidature.training?.id, candidature.interestLevel, candidature.response, candidature.read)}>
              Voir le profil
            </MenuItem>
            <MenuItem disableRipple disableFocusRipple onClick={() => contactMember(candidature.applicant?.id, candidature.training?.id)}>
              Contacter
            </MenuItem>

            {/* ALLOW AFFILIATIONS ONLY IF PREMIUM SUBSCRIPTION */}
            {/* frontend restriction */}
            {candidature.response === 'ACCEPTED' && isPremium &&
              <MenuItem disableRipple disableFocusRipple onClick={() => addAffiliation(candidature.applicant, candidature.training)}>
                Ajouter à mes affiliations
              </MenuItem>
            }
            {candidature.response === 'PENDING' && <>
              <MenuItem disableRipple disableFocusRipple onClick={() => acceptCandidature(candidature.applicant?.id, candidature.training?.id)}>
                Accepter la candidature
              </MenuItem>
              <MenuItem onClick={() => rejectCandidature(candidature.applicant?.id, candidature.training?.id)}>
                Refuser la candidature
              </MenuItem>
            </>}
          </Menu>
        </div>
        <div className={classes.row}>
          <SchoolIcon className={global.infoIcon} />
          <span className={global.infoText}>{candidature.training?.degree?.label}</span>
        </div>
        <div className={classes.row}>
          <WorkIcon className={global.infoIcon} />
          <span className={global.infoText}>{candidature.training?.label}</span>
        </div>
        <div className={classes.row}>
          <DescriptionIcon className={global.infoIcon} />
          <span className={global.infoText}>{candidature.training?.trainingType?.label}</span>
        </div>
        <div className={classes.row}>
          <LocationOnIcon className={global.infoIcon} />
          <span className={global.infoText}>{candidature.training?.address?.cityCode} {candidature.training?.address?.city}</span>
        </div>
        <div className={classes.row}>
          <Event className={global.infoIcon} />
          <span className={global.infoText}>
            <FormattedDate
              day="numeric"
              month="long"
              value={candidature.applicationDate}
              year="numeric"
            />
          </span>
        </div>
        <div className={classes.row}>
          {candidature.read ?
            <Chip
              classes={{
                colorPrimary: css({
                  background: '#DBFAD8',
                  color: '#008000',
                }),
              }}
              className={classes.chip}
              color="primary"
              label="Profil: Examiné"
              size="small"
            />
            :
            <Chip
              classes={{
                colorPrimary: css({
                  background: '#F3F7FF',
                  color: '#5D75A8',
                }),
              }}
              className={classes.chip}
              color="primary"
              label="Profil: Non examiné"
              size="small"
            />
          }
        </div>
        <div className={classes.row}>
          {getInterestChip(candidature.interestLevel)}
        </div>
        <div className={classes.row}>
          {getStatusChip(candidature.response)}
        </div>
        <Button
          className={css({ marginTop: spacing(1) })}
          onClick={() => viewCV(candidature.applicant?.id, candidature.training?.id, candidature.interestLevel, candidature.response, candidature.read)}
          variant="outlined"
        >
          <FormattedMessage id="school.formationsCandidats.btnVoirCandidat" />
        </Button>

      </Paper>
    </Grid>
  )
}

const styles = ({ spacing }) => ({
  paper: {
    padding: spacing(2.5),
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    boxShadow: 'none',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),
    position: 'relative',
  },
  avatar: {
    height: 80,
    width: 80,
    background: '#5A6DA1',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(0.5)
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    marginTop: '4px',
    borderRadius: '10.0px',
    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  },
  roomIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: -5,
    color: '#5D75A8',
  }
});

export default CardCandidat